
        <div *ngIf="hasAccess" class="row">
            <div class="col-lg-8 col-md-7 col-xs-12">
                <button type="button" class="btn btn-large btn-deny" style="margin-left:5px;" (click)="refresh()">Refresh</button>
                <a style="margin-left:10px;cursor: pointer;" (click)="goBack()">Go Back</a>
            </div>
            <div class="col-lg-8 col-md-12 col-xs-12">
                <div class="card">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Identakid School</th>
                                <th>OneRoster School</th>
                                <th>Sync Students</th>
                                <th>Sync Student Contacts</th>
                                <th>Changed At</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of schoolMapView; let i = index" style="height: 55px;">
                                <td style="width:18%;">{{ row.iakSchoolName }}</td>
                                <td style="width:20%;">
                                    <div *ngIf="!isEditMode(i) && isRowMapped(row.oneRosterSchoolId)">
                                        {{ orgName(row.oneRosterSchoolId) }}
                                    </div>
                                    <select *ngIf="isEditMode(i)" [(ngModel)]="currentRow.oneRosterSchoolId" class="form-control" title="Organization">
                                        <option *ngFor="let org of orgsDropdown" [value]="org.id">{{org.title}}</option>
                                    </select>
                                </td>
                                <td style="width:12%;">
                                    <div *ngIf="!isEditMode(i) && isRowMapped(row.oneRosterSchoolId)">
                                        {{ row.syncStudents ? 'On' : 'Off' }}
                                    </div>
                                    <app-toggle *ngIf="isEditMode(i)" [(toggle)]="currentRow.syncStudents"></app-toggle>
                                </td>
                                <td style="width:15%;">
                                    <div *ngIf="!isEditMode(i) && isRowMapped(row.oneRosterSchoolId)">
                                        {{ row.syncStudentContacts ? 'On' : 'Off' }}
                                    </div>
                                    <app-toggle style="text-align:center;" *ngIf="isEditMode(i)" [(toggle)]="currentRow.syncStudentContacts"></app-toggle>
                                </td>
                                <td style="width:15%;">
                                    <div *ngIf="isRowMapped(row.oneRosterSchoolId)">
                                        {{ isDateSet(row.updatedAt) ? (row.updatedAt | date: 'MM/dd/y HH:mm') : ''}}
                                    </div>
                                </td>
                                <td style="width:20%;">
                                    <span *ngIf="!isEditMode(i)" title="Edit" class="btn-link" style="cursor: pointer;" (click)="edit(row, i)">Edit</span>

                                    <div *ngIf="isEditMode(i)">
                                        <span title="Save" class="btn-link" style="cursor: pointer;" (click)="save(row, i)">Save</span>
                                        <span> | </span>
                                        <span title="Cancel" class="btn-link" style="cursor: pointer;" (click)="cancel()">Cancel</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="row mt2" [hidden]="msg.msg == ''">
                    <alert [alert]="msg"></alert>
                </div>
            </div>
        </div>
    